import { FormControl, FormGroup } from '@angular/forms';
import { BookerFlightWithControls } from '@shared/booker/types/booker-flight.type';

export function newMultiCityFormRow(): FormGroup<BookerFlightWithControls> {
  return new FormGroup({
    fromAirport: new FormControl(),
    toAirport: new FormControl(),
    departureDate: new FormControl(),
  });
}
